<script lang="ts">
  import { translate } from "lib";
  import { dialogData } from "stores";
  import { ButtonComponent } from "ui";

  export let data: any;
  let isDeleting = false;

  const onDelete = async (): Promise<void> => {
    if (isDeleting) {
      return;
    }

    isDeleting = true;

    try {
      await data.executeFunction();
      $dialogData = { data: {}, type: "" } as any;
    } catch (error) {
      console.error("Delete confirmation failed", error);
    } finally {
      isDeleting = false;
    }
  };

  let stage = 1;
</script>

<div class="flex flex-col justify-center items-center">
  <h3 class="text-lg mt-5 mb-5">
    {translate("DELETE")}
    {data.title.toLowerCase()}
  </h3>
  <div>
    <ButtonComponent
      cy="confirm-delete-button"
      myClasses="bg-red"
      customColor="bg-red-500 hover:bg-red-800 focus:ring-red-800"
      disabled={isDeleting}
      isLoading={isDeleting}
      on:click={onDelete}
    >
      {translate("DELETE")}
    </ButtonComponent>
  </div>
  <div class="mb-5"></div>
</div>
